module.exports = (__webpack_require__(11))(8);


//////////////////
// WEBPACK FOOTER
// delegated ../../node_modules/webpack/buildin/global.js from dll-reference vendor_lib
// module id = 30
// module chunks = 0